import React from "react";
import style from "./IconSuggest.module.scss";
import axios from "axios";
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
import { DB_ICON_TAB_LIST } from "../../../../constants/constants";
import { useTranslation } from "react-i18next";

type Props = {
  client: string;
  pageId: number;
  pageType: string;
  selectTab: { tabName: string; iconKey: string };
  iconData: Record<string, any>;
  setCurrentIcon: React.Dispatch<React.SetStateAction<{ unicode: string | null; image_path: string | null }>>;
  setIsIconOpen: (isOpen: boolean) => void;
};

type Icon = {
  icon_id: number;
  unicode?: string;
  image_path?: string;
};

type IconCategory = "unicode" | "image_path";

export const IconList = ({ client, pageId, pageType, selectTab, iconData, setCurrentIcon, setIsIconOpen }: Props) => {
  const { t } = useTranslation();

  const registerIcon = async (iconId: number) => {
    await axios.patch(`/${client}/icons/${pageType}/${pageId}`, {
      icon_id: iconId,
    });
  };

  const formatIconData = (icon: Icon, iconCategory: IconCategory) => {
    return iconCategory === "unicode"
      ? { unicode: icon.unicode ?? null, image_path: null }
      : { unicode: null, image_path: icon.image_path ?? null };
  };

  const registerIconFunc = (icon: Icon, iconCategory: IconCategory) => {
    registerIcon(icon.icon_id);
    setCurrentIcon(formatIconData(icon, iconCategory));
    setIsIconOpen(false);
  };

  return (
    <div style={{ maxHeight: "420px", overflow: "scroll" }}>
      {DB_ICON_TAB_LIST.map((tabInfo, i) => (
        <div
          key={i}
          style={{
            display:
              selectTab.tabName === t("IconList.すべて") || selectTab.tabName === tabInfo.tabName ? "block" : "none",
          }}
        >
          {iconData[tabInfo.iconKey]?.length ? (
            <small style={{ marginLeft: "16px", color: "#777777" }}>
              {tabInfo.tabName === t("IconList.すべて") ? t("IconList.最近") : tabInfo.tabName}
            </small>
          ) : (
            <></>
          )}

          <>
            {(
              selectTab.tabName === t("IconList.すべて")
                ? iconData[tabInfo.iconKey]?.length
                : iconData[selectTab.iconKey]?.length
            ) ? (
              <div id={`label`} className={`${style.iconSelection} test-selection-label d-flex flex-wrap`} tabIndex={0}>
                <>
                  {iconData[tabInfo.iconKey]?.map((icon: Icon, i: number) =>
                    icon.unicode ? (
                      <span key={i} className={style.unicodeStyle} onClick={() => registerIconFunc(icon, "unicode")}>
                        {icon.unicode}
                      </span>
                    ) : (
                      <span key={i} className={style.imageStyle} onClick={() => registerIconFunc(icon, "image_path")}>
                        <img src={icon.image_path} width="28" height="28" />
                      </span>
                    ),
                  )}
                </>
              </div>
            ) : (
              <></>
            )}
          </>
        </div>
      ))}
      {(selectTab.tabName === t("IconList.すべて")
        ? !Object.values(iconData) && !Object.values(iconData).some((v) => v.length)
        : !iconData[selectTab.iconKey]?.length) && (
        <div id={`label`} className={`${style.iconSelection} test-selection-label d-flex flex-wrap`} tabIndex={0}>
          <span
            style={{
              color: "#cacaca",
              fontSize: "10px",
              padding: "6px",
            }}
          >
            {t("IconList.該当のアイコンが存在しません。")}
          </span>
        </div>
      )}
    </div>
  );
};
